import React, { useState, useEffect } from 'react';
import '../styles/CookieBanner.css';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true, // Always true, cannot be disabled
    analytics: false,
    marketing: false
  });
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('nvf_cookie_consent');
    if (!consent) {
      // Show banner after 1 second
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const saveConsent = (acceptAll = false) => {
    const consentData = {
      timestamp: new Date().toISOString(),
      essential: true,
      analytics: acceptAll || preferences.analytics,
      marketing: acceptAll || preferences.marketing
    };

    localStorage.setItem('nvf_cookie_consent', JSON.stringify(consentData));
    setIsVisible(false);

    // Log consent in backend (optional)
    logConsent(consentData);
  };

  const logConsent = async (consentData) => {
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API_URL}/api/consent-log`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'cookie_consent',
          data: consentData,
          userAgent: navigator.userAgent
        })
      });
    } catch (error) {
      console.error('Failed to log consent:', error);
    }
  };

  const handleAcceptAll = () => {
    saveConsent(true);
  };

  const handleAcceptSelected = () => {
    saveConsent(false);
  };

  const handleRejectAll = () => {
    setPreferences({ essential: true, analytics: false, marketing: false });
    saveConsent(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <div className="cookie-banner-content">
          <h3>🍪 Respect de votre vie privée</h3>
          <p>
            Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
            En conformité avec la <strong>Loi 25 du Québec</strong>, nous vous demandons 
            votre consentement pour utiliser certains cookies.
          </p>

          {!showDetails ? (
            <div className="cookie-banner-actions">
              <button onClick={handleAcceptAll} className="cookie-btn cookie-btn-accept">
                Tout accepter
              </button>
              <button onClick={handleRejectAll} className="cookie-btn cookie-btn-reject">
                Refuser tout
              </button>
              <button 
                onClick={() => setShowDetails(true)} 
                className="cookie-btn cookie-btn-customize"
              >
                Personnaliser
              </button>
            </div>
          ) : (
            <div className="cookie-preferences">
              <div className="cookie-category">
                <div className="cookie-category-header">
                  <input 
                    type="checkbox" 
                    checked={true} 
                    disabled 
                    id="essential"
                  />
                  <label htmlFor="essential">
                    <strong>Cookies essentiels</strong> (obligatoires)
                  </label>
                </div>
                <p className="cookie-category-desc">
                  Nécessaires au fonctionnement du site (navigation, formulaires, sécurité).
                </p>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <input 
                    type="checkbox" 
                    checked={preferences.analytics}
                    onChange={(e) => setPreferences({...preferences, analytics: e.target.checked})}
                    id="analytics"
                  />
                  <label htmlFor="analytics">
                    <strong>Cookies analytiques</strong> (optionnels)
                  </label>
                </div>
                <p className="cookie-category-desc">
                  Nous aident à comprendre comment vous utilisez le site pour l'améliorer.
                </p>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <input 
                    type="checkbox" 
                    checked={preferences.marketing}
                    onChange={(e) => setPreferences({...preferences, marketing: e.target.checked})}
                    id="marketing"
                  />
                  <label htmlFor="marketing">
                    <strong>Cookies marketing</strong> (optionnels)
                  </label>
                </div>
                <p className="cookie-category-desc">
                  Permettent de personnaliser les publicités et mesurer leur efficacité.
                </p>
              </div>

              <div className="cookie-banner-actions">
                <button onClick={handleAcceptSelected} className="cookie-btn cookie-btn-accept">
                  Enregistrer mes choix
                </button>
                <button 
                  onClick={() => setShowDetails(false)} 
                  className="cookie-btn cookie-btn-back"
                >
                  Retour
                </button>
              </div>
            </div>
          )}

          <div className="cookie-banner-footer">
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
              Politique de confidentialité
            </a>
            {' | '}
            <a href="/data-deletion" target="_blank" rel="noopener noreferrer">
              Demander la suppression de mes données
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
